'use client';

import React, { useEffect, useRef, useState } from 'react';
import ScrollAnimation from './scrollAnimation';
import CardAnimation from './cardAnimation';

import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Container, Row } from 'react-bootstrap';

import web1 from './assets/images/web1.webp'
import web2 from './assets/images/web2.webp'
import web3 from './assets/images/web3.webp'
import web4 from './assets/images/web4.webp'

import uiux1 from './assets/images/uiux1.jpg'
import uiux2 from './assets/images/uiux2.jpg'
import uiux3 from './assets/images/uiux3.jpg'
import uiux4 from './assets/images/uiux4.jpg'
import uiux5 from './assets/images/uiux5.jpg'
import uiux6 from './assets/images/uiux6.jpg'


import what1 from './assets/images/what1.webp'
import what2 from './assets/images/what2.webp'
import what3 from './assets/images/what3.webp'
import what4 from './assets/images/what4.webp'

import brand1 from './assets/images/brand1.webp'
import brand2 from './assets/images/brand2.webp'
import brand3 from './assets/images/brand3.webp'
import brand4 from './assets/images/brand4.webp'



import ssm1 from './assets/images/ssm1.webp'
import ssm2 from './assets/images/ssm2.webp'
import ssm3 from './assets/images/ssm3.webp'
import ssm4 from './assets/images/ssm4.webp'
import ssm5 from './assets/images/ssm5.webp'
import ssm6 from './assets/images/ssm6.webp'
import ssm7 from './assets/images/ssm7.webp'
import ssm8 from './assets/images/ssm8.webp'



import logo from './assets/images/muhammd-logo-white.webp'

import './herobg.scss'
import Section1Bg from './Section1Bg';

import scrollButton from './assets/images/scrollDownImg.webp'
import scrollButtonText from './assets/images/scrollDownText.webp'

import { motion, useScroll, useTransform } from "framer-motion";
import Carousel3D from './3dCarousel';
import HorizontalScrollSection2 from './HorizontalScroll2';
import WhatWeDone from './WhatWeDone';
import ReviewsSection from './ReviewsSection';

import Typewriter from 'typewriter-effect';
import CardAnimationWeb from './cardAnimationWeb';
import Footer from './Footer';

import headerIcon1 from './assets/images/headerIcon1.webp'
import headerIcon2 from './assets/images/headerIcon2.webp'
import headerIcon3 from './assets/images/headerIcon3.webp'
import headerIcon4 from './assets/images/headerIcon4.webp'
import headerIcon5 from './assets/images/headerIcon5.webp'

import partner1 from './assets/images/partner1.webp'
import partner2 from './assets/images/partner2.webp'
import partner3 from './assets/images/partner3.webp'
import partner4 from './assets/images/partner4.webp'
import partner5 from './assets/images/partner5.webp'
import partner6 from './assets/images/partner6.webp'
import partner7 from './assets/images/partner7.webp'
import partner8 from './assets/images/partner8.webp'
import partner9 from './assets/images/partner9.webp'
import partner10 from './assets/images/partner10.webp'

import video from './assets/images/animatedVideo.webm'

import Slider from 'react-slick';
import { TweenLite } from 'gsap/gsap-core';
import { Circ } from 'gsap';

const hiddenMask = `repeating-linear-gradient(to right, rgba(0,0,0,0) 0px, rgba(0,0,0,0) 30px, rgba(0,0,0,1) 30px, rgba(0,0,0,1) 30px)`;
const visibleMask = `repeating-linear-gradient(to right, rgba(0,0,0,0) 0px, rgba(0,0,0,0) 0px, rgba(0,0,0,1) 0px, rgba(0,0,0,1) 30px)`;

const App = () => {

  var settings = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
    ]
  };

  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoaded2, setIsLoaded2] = useState(false);
  const [isLoaded3, setIsLoaded3] = useState(false);
  const [isLoaded4, setIsLoaded4] = useState(false);
  const [isLoaded5, setIsLoaded5] = useState(false);
  const [isLoaded6, setIsLoaded6] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const [isInView2, setIsInView2] = useState(false);
  const [isInView3, setIsInView3] = useState(false);
  const [isInView4, setIsInView4] = useState(false);
  const [isInView5, setIsInView5] = useState(false);
  const [isInView6, setIsInView6] = useState(false);

  const containerRef = useRef(null);
  const containerRef2 = useRef(null);

  const { scrollYProgress: myScrollProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end end"]
  });
  const { scrollYProgress: myScrollProgress2 } = useScroll({
    target: containerRef2,
    offset: ["start end", "end end"]
  });

  const imageValue = useTransform(myScrollProgress, [0, 1], window.screen.width > 650 ? ["100%", "0%"] : ["0%", "0%"]);
  const imageValue3 = useTransform(myScrollProgress, [0, 1], window.screen.width > 650 ? ["100%", "-100%"] : ["0%", "0%"]);
  const imageValue2 = useTransform(myScrollProgress2, [0, 1], window.screen.width > 650 ? ["10%", "0%"] : ["0%", "0%"]);

  const openNav = () => {
    document.getElementById("mysidenav").style.width = "100%";
  }

  const closeNav = () => {
    document.getElementById("mysidenav").style.width = "0";
  }

  useEffect(() => {
    if (window.screen.width > 500) {
      if (document.getElementById("circleAnimation1")) {
        setTimeout(() => {
          document.getElementById("circleAnimation1").style.width = window.screen.width <= 425 ? "50px" : window.screen.width <= 768 && window.screen.width >= 600 ? "60px" : window.screen.width <= 992 && window.screen.width >= 768 ? "80px" : window.screen.width <= 1250 && window.screen.width >= 992 ? "100px" : window.screen.width >= 1400 ? '200px' : "150px"
        }, 2000)

        setTimeout(() => {
          document.getElementById("circleAnimation1").style.width = window.screen.width <= 425 ? "20px" : window.screen.width <= 768 && window.screen.width >= 600 ? "20px" : window.screen.width <= 1250 && window.screen.width >= 768 ? "30px" : window.screen.width >= 1400 ? '62px' : "45px"
        }, 5000)

        setInterval(() => {

          setTimeout(() => {
            document.getElementById("circleAnimation1").style.width = window.screen.width <= 425 ? "50px" : window.screen.width <= 768 && window.screen.width >= 600 ? "60px" : window.screen.width <= 992 && window.screen.width >= 768 ? "80px" : window.screen.width <= 1250 && window.screen.width >= 992 ? "100px" : window.screen.width >= 1400 ? '200px' : "150px"
          }, 0)

          setTimeout(() => {
            document.getElementById("circleAnimation1").style.width = window.screen.width <= 425 ? "20px" : window.screen.width <= 768 && window.screen.width >= 600 ? "20px" : window.screen.width <= 1250 && window.screen.width >= 768 ? "30px" : window.screen.width >= 1400 ? '62px' : "45px"
          }, 3000)
        }, 8000);
      }
    }
  }, [])

  useEffect(() => {
    if (window.screen.width > 500) {
      if (document.getElementById("circleAnimation2")) {
        setTimeout(() => {
          document.getElementById("circleAnimation2").style.width = window.screen.width <= 425 ? "50px" : window.screen.width <= 768 && window.screen.width >= 600 ? "60px" : window.screen.width <= 992 && window.screen.width >= 768 ? "80px" : window.screen.width <= 1250 && window.screen.width >= 992 ? "100px" : window.screen.width >= 1400 ? '200px' : "150px"
        }, 3000)

        setTimeout(() => {
          document.getElementById("circleAnimation2").style.width = window.screen.width <= 425 ? "20px" : window.screen.width <= 768 && window.screen.width >= 600 ? "20px" : window.screen.width <= 1250 && window.screen.width >= 768 ? "30px" : window.screen.width >= 1400 ? '62px' : "45px"
        }, 6000)

        setInterval(() => {

          setTimeout(() => {
            document.getElementById("circleAnimation2").style.width = window.screen.width <= 425 ? "50px" : window.screen.width <= 768 && window.screen.width >= 600 ? "60px" : window.screen.width <= 992 && window.screen.width >= 768 ? "80px" : window.screen.width <= 1250 && window.screen.width >= 992 ? "100px" : window.screen.width >= 1400 ? '200px' : "150px"
          }, 1000)

          setTimeout(() => {
            document.getElementById("circleAnimation2").style.width = window.screen.width <= 425 ? "20px" : window.screen.width <= 768 && window.screen.width >= 600 ? "20px" : window.screen.width <= 1250 && window.screen.width >= 768 ? "30px" : window.screen.width >= 1400 ? '62px' : "45px"
          }, 4000)
        }, 8000);
      }
    }
  }, [])

  useEffect(() => {
    if (window.screen.width > 500) {


      if (document.getElementById('large-header') && document.getElementById('demo-canvas')) {
        (function () {

          var width, height, largeHeader, canvas, ctx, points, target, animateHeader = true;

          // Main
          initHeader();
          initAnimation();
          addListeners();

          function initHeader() {
            width = window.innerWidth;
            height = window.innerHeight;
            target = { x: width / 2, y: height / 2 };

            largeHeader = document.getElementById('large-header');
            largeHeader.style.height = height + 'px';

            canvas = document.getElementById('demo-canvas');
            canvas.width = width;
            canvas.height = height;
            ctx = canvas.getContext('2d');

            // create points
            points = [];
            for (var x = 0; x < width; x = x + width / 20) {
              for (var y = 0; y < height; y = y + height / 20) {
                var px = x + Math.random() * width / 20;
                var py = y + Math.random() * height / 20;
                var p = { x: px, originX: px, y: py, originY: py };
                points.push(p);
              }
            }

            // for each point find the 5 closest points
            for (var i = 0; i < points.length; i++) {
              var closest = [];
              var p1 = points[i];
              for (var j = 0; j < points.length; j++) {
                var p2 = points[j]
                if (!(p1 == p2)) {
                  var placed = false;
                  for (var k = 0; k < 5; k++) {
                    if (!placed) {
                      if (closest[k] == undefined) {
                        closest[k] = p2;
                        placed = true;
                      }
                    }
                  }

                  for (var k = 0; k < 5; k++) {
                    if (!placed) {
                      if (getDistance(p1, p2) < getDistance(p1, closest[k])) {
                        closest[k] = p2;
                        placed = true;
                      }
                    }
                  }
                }
              }
              p1.closest = closest;
            }

            // assign a circle to each point
            for (var i in points) {
              var c = new Circle(points[i], 2 + Math.random() * 2, 'rgba(255,255,255,0.3)');
              points[i].circle = c;
            }
          }

          // Event handling
          function addListeners() {
            if (!('ontouchstart' in window)) {
              window.addEventListener('mousemove', mouseMove);
            }
            window.addEventListener('scroll', scrollCheck);
            window.addEventListener('resize', resize);
          }

          function mouseMove(e) {
            var posx = 0;
            var posy = 0;
            if (e.pageX || e.pageY) {
              posx = e.pageX;
              posy = e.pageY;
            }
            else if (e.clientX || e.clientY) {
              posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
              posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
            }
            target.x = posx;
            target.y = posy;
          }

          function scrollCheck() {
            if (document.body.scrollTop > height) animateHeader = false;
            else animateHeader = true;
          }

          function resize() {
            width = window.innerWidth;
            height = window.innerHeight;
            largeHeader.style.height = height + 'px';
            canvas.width = width;
            canvas.height = height;
          }

          // animation
          function initAnimation() {
            animate();
            for (var i in points) {
              shiftPoint(points[i]);
            }
          }

          function animate() {
            if (animateHeader) {
              ctx.clearRect(0, 0, width, height);
              for (var i in points) {
                // detect points in range
                if (Math.abs(getDistance(target, points[i])) < 4000) {
                  points[i].active = 0.3;
                  points[i].circle.active = 0.6;
                } else if (Math.abs(getDistance(target, points[i])) < 20000) {
                  points[i].active = 0.1;
                  points[i].circle.active = 0.3;
                } else if (Math.abs(getDistance(target, points[i])) < 40000) {
                  points[i].active = 0.02;
                  points[i].circle.active = 0.1;
                } else {
                  points[i].active = 0;
                  points[i].circle.active = 0;
                }

                drawLines(points[i]);
                points[i].circle.draw();
              }
            }
            requestAnimationFrame(animate);
          }

          function shiftPoint(p) {
            TweenLite.to(p, 1 + 1 * Math.random(), {
              x: p.originX - 50 + Math.random() * 100,
              y: p.originY - 50 + Math.random() * 100, ease: Circ.easeInOut,
              onComplete: function () {
                shiftPoint(p);
              }
            });
          }

          // Canvas manipulation
          function drawLines(p) {
            if (!p.active) return;
            for (var i in p.closest) {
              ctx.beginPath();
              ctx.moveTo(p.x, p.y);
              ctx.lineTo(p.closest[i].x, p.closest[i].y);
              ctx.strokeStyle = 'rgba(156,217,249,' + p.active + ')';
              ctx.stroke();
            }
          }

          function Circle(pos, rad, color) {
            var _this = this;

            // constructor
            (function () {
              _this.pos = pos || null;
              _this.radius = rad || null;
              _this.color = color || null;
            })();

            this.draw = function () {
              if (!_this.active) return;
              ctx.beginPath();
              ctx.arc(_this.pos.x, _this.pos.y, _this.radius, 0, 2 * Math.PI, false);
              ctx.fillStyle = 'rgb(128,128,128,' + _this.active + ')';
              ctx.fill();
            };
          }

          // Util
          function getDistance(p1, p2) {
            return Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2);
          }

        })();
      }
    }
  }, [])

  return (
    <div>

      <div ref={containerRef} style={{ background: "#fff" }}>

        <header>
          <div className='container web'>
            <div className='row justify-content-between align-items-center'>
              <div className='col-md-3'>
                <a href='https://muhammadprojects.com/' aria-label='logo'>
                  <div className='logo-div'>
                    <img src={logo} alt='logo' />
                  </div>
                </a>
              </div>
              <div className='col-md-9'>
              <ul className='navLinks'>
  <li><a href='https://muhammadprojects.com/'>HOME</a></li>
  <li><a href='https://clients.muhammadprojects.com/new-muhammad/case-study/'>CASE STUDY</a></li>
  <li><a href='https://clients.muhammadprojects.com/new-muhammad/web_design/'>WEB DESIGN</a></li>
  <li><a href='https://clients.muhammadprojects.com/new-muhammad/logos/'>LOGO</a></li>
  <li><a href='https://clients.muhammadprojects.com/new-muhammad/branding/'>BRANDING</a></li>
  <li><a href='https://clients.muhammadprojects.com/new-muhammad/ui-ux/'>UI / UX</a></li>
  <li><a href='https://clients.muhammadprojects.com/new-muhammad/social-media/'>SOCIAL MEDIA</a></li>
  <li className="dropdown">
    <a href='https://clients.muhammadprojects.com/new-muhammad/graphic-design/'>GRAPHIC DESIGN</a>
    <ul className="dropdown-menu">
      <li><a href='https://clients.muhammadprojects.com/new-muhammad/graphic-category/branding/'>Branding</a></li>
      <li><a href='https://clients.muhammadprojects.com/new-muhammad/graphic-category/packaging/'>Packaging</a></li>
      <li><a href='https://clients.muhammadprojects.com/new-muhammad/graphic-category/print/'>Print</a></li>
      <li><a href='https://clients.muhammadprojects.com/new-muhammad/graphic-category/stationary/'>Stationary</a></li>
    </ul>
  </li>
</ul>
              </div>
            </div>
          </div>

          <div className='nav mobile'>
            <a href='/' aria-label='logo'>
              <div className='logo-div'>
                <img src={logo} alt='logo' />
              </div>
            </a>

            <div className='menuIcon' onClick={openNav}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#fff" class="bi bi-list" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" />
              </svg>
            </div>

            <div id="mysidenav" class="sidenav">
              <a href="https://muhammadprojects.com/" class="closebtn" onClick={closeNav}>
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
              </a>

              {/* <a href='https://muhammadprojects.com/'>HOME</a>
              <a href='https://clients.muhammadprojects.com/new-muhammad/case-study/'>CASE STUDY</a>
              <a href='https://clients.muhammadprojects.com/new-muhammad/web_design/'>WEB DESIGN</a>
              <a href='https://clients.muhammadprojects.com/new-muhammad/logos/'>LOGO</a>
              <a href='https://clients.muhammadprojects.com/new-muhammad/branding/'>BRANDING</a>
              <a href='https://clients.muhammadprojects.com/new-muhammad/ui-ux/'>UI / UX</a>
              <a href='https://clients.muhammadprojects.com/new-muhammad/social-media/'>SOCIAL MEDIA</a>
              <a class="mobile-drop-down-menu" href='https://clients.muhammadprojects.com/new-muhammad/graphic-design/'>GRAPHIC DESIGN <i class="fa fa-angle-down" aria-hidden="true"></i></a> */}


<nav class="mobile-menu">
  <a href='https://muhammadprojects.com/'>HOME</a>
  <a href='https://clients.muhammadprojects.com/new-muhammad/case-study/'>CASE STUDY</a>
  <a href='https://clients.muhammadprojects.com/new-muhammad/web_design/'>WEB DESIGN</a>
  <a href='https://clients.muhammadprojects.com/new-muhammad/logos/'>LOGO</a>
  <a href='https://clients.muhammadprojects.com/new-muhammad/branding/'>BRANDING</a>
  <a href='https://clients.muhammadprojects.com/new-muhammad/ui-ux/'>UI / UX</a>
  <a href='https://clients.muhammadprojects.com/new-muhammad/social-media/'>SOCIAL MEDIA</a>
  <div class="mobile-drop-down-container">
             <div className='mobile-menu-toggle'>
             <a class="mobile-drop-down-link" href='https://clients.muhammadprojects.com/new-muhammad/graphic-design/'>GRAPHIC DESIGN</a>
  <i class="fa fa-angle-down mobile-drop-down-icon" aria-hidden="true"></i>
  </div> 
  <ul class="mobile-drop-down-menu-box">
    <li><a href='https://clients.muhammadprojects.com/new-muhammad/graphic-category/branding/'>Branding</a></li>
    <li><a href='https://clients.muhammadprojects.com/new-muhammad/graphic-category/packaging/'>Packaging</a></li>
    <li><a href='https://clients.muhammadprojects.com/new-muhammad/graphic-category/print/'>Print</a></li>
    <li><a href='https://clients.muhammadprojects.com/new-muhammad/graphic-category/stationary/'>Stationary</a></li>
  </ul>
</div>
</nav>
    
              <div className='logo-div'>
                <a href='/' aria-label='logo'>
                  <img src={logo} alt='logo' />
                </a>
              </div>
            </div>
          </div>
        </header>

        {/* <div className='hero-div'>
          <div className='iconsDiv'>
            <img src={headerIcon1} alt='php' />
            <img src={headerIcon2} alt='html' />
            <img src={headerIcon3} alt='react' />
            <img src={headerIcon4} alt='wordpress' />
            <img src={headerIcon5} alt='g' />
          </div>
          <div className='scrollButton'>
            <a href='#what-we-do' className='bounce'>
              <img className='scrollText' src={scrollButtonText} alt='scroll' />
              <img className='img' src={scrollButton} alt='scroll' />
            </a>
          </div>
          <Section1Bg />
          <Container>
            <motion.div className="img-inner" style={{ translateY: imageValue3 }}>
              <Row>
                <Col md={12}>
                  <h5>
                    <Typewriter
                      options={{
                        strings: ['Hi, I’m Muhammad'],
                        autoStart: true,
                        loop: true,
                      }}
                    />
                  </h5>
                  <h1>
                    I help enhance business<br /> through <Typewriter
                      options={{
                        strings: ['Branding', 'Designing', "Development"],
                        autoStart: true,
                        loop: true,
                      }}
                    />
                  </h1>
                </Col>
              </Row>
            </motion.div>
          </Container>
        </div> */}

        <div className='heroDivNew'>
          <div id="large-header" class="large-header">
            <canvas id="demo-canvas"></canvas>
          </div>
          <Container>
            <h1>
              IDEAS C<span id='circleAnimation1' className='circleAnimation'></span>NNECT
            </h1>
            <div className='flexDiv'>
              <div className='flex-div1'>
                <h1>THR<span id='circleAnimation2' className='circleAnimation'></span>UGH</h1>
                <div className='sideDiv'>

                  <h1>
                    <div data-w-id="a21b7f03-16e6-4d84-2816-1bc763f31cfb" class="svg_div">
                      <div class="slicica_aset w-embed">
                        <svg width="100%" height="100%" viewBox="0 0 82 82" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M41.0554 41.3351C41.1664 41.3342 41.2725 41.2894 41.3507 41.2104C41.4289 41.1315 41.4727 41.0247 41.4727 40.9135C41.4732 40.8446 41.46 40.7764 41.4341 40.7127C41.4081 40.649 41.3698 40.591 41.3214 40.5422C41.273 40.4934 41.2154 40.4546 41.152 40.4282C41.0886 40.4017 41.0206 40.3881 40.9519 40.3881C40.7748 40.3881 40.605 40.4586 40.4798 40.5841C40.3546 40.7096 40.2842 40.8799 40.2842 41.0574C40.2842 41.2757 40.3708 41.4851 40.5248 41.6394C40.6788 41.7938 40.8877 41.8805 41.1055 41.8805C41.3768 41.8796 41.6366 41.771 41.8281 41.5785C42.0196 41.3859 42.1271 41.1251 42.1271 40.8532C42.1275 40.6848 42.0948 40.518 42.0307 40.3623C41.9666 40.2066 41.8724 40.0651 41.7536 39.946C41.6347 39.8269 41.4936 39.7326 41.3383 39.6683C41.1829 39.6041 41.0165 39.5712 40.8484 39.5716C40.6383 39.5712 40.4302 39.6124 40.2359 39.6928C40.0417 39.7732 39.8653 39.8912 39.7167 40.0401C39.5681 40.189 39.4503 40.3659 39.3701 40.5606C39.2899 40.7552 39.2488 40.9639 39.2493 41.1745C39.2493 41.707 39.4603 42.2176 39.836 42.5942C40.2116 42.9707 40.7211 43.1822 41.2524 43.1822C41.915 43.1813 42.5502 42.9169 43.0184 42.4469C43.4866 41.977 43.7496 41.34 43.7496 40.6759C43.7496 40.265 43.6689 39.8582 43.512 39.4786C43.3551 39.099 43.1252 38.7541 42.8354 38.4636C42.5455 38.173 42.2014 37.9426 41.8227 37.7854C41.4439 37.6281 41.038 37.5472 40.6281 37.5472C40.1142 37.545 39.6049 37.6445 39.1294 37.8401C38.654 38.0357 38.2218 38.3235 37.8576 38.687C37.4934 39.0504 37.2045 39.4824 37.0073 39.9581C36.8101 40.4338 36.7086 40.9438 36.7086 41.4589C36.7095 42.7561 37.224 43.9999 38.1392 44.9172C39.0544 45.8345 40.2954 46.3502 41.5896 46.3511C43.2073 46.3511 44.7587 45.707 45.9026 44.5605C47.0465 43.4139 47.6891 41.859 47.6891 40.2375C47.6891 38.2106 46.8858 36.2666 45.4557 34.8333C44.0257 33.4 42.0862 32.5948 40.0639 32.5948C37.536 32.5948 35.1116 33.6013 33.3241 35.3929C31.5365 37.1846 30.5323 39.6145 30.5323 42.1482C30.5332 45.315 31.789 48.3518 34.0234 50.5908C36.2579 52.8297 39.2881 54.0875 42.4476 54.0875C46.3975 54.0875 50.1857 52.5148 52.9787 49.7154C55.3355 47.3531 56.8209 44.2807 57.2273 41M81 41C81 63.0914 63.0914 81 41 81M81 41H80.6273M81 41C81 39.9386 80.9587 38.8869 80.8775 37.8463M41 81C18.9086 81 1 63.0914 1 41M41 81V41M1 41C1 18.9086 18.9086 1 41 1M1 41H41M41 1C62.03 1 79.2695 17.2291 80.8775 37.8463M41 1V20.6447M41 41L21 75.641M41 41L75.641 61M41 41L6.35901 21M41 41L6.35901 61M41 41L61 75.641M41 41L21 6.35901M41 41L56.0418 32.3156M41 41L50.4348 24.6585M41 41V20.6447M41 41H57.2273M61 6.35901L50.4348 24.6585M75.641 21L56.0418 32.3156M80.6273 41C80.756 39.9542 80.8396 38.902 80.8775 37.8463M80.6273 41H57.2273M80.6273 41C80.2268 44.2524 79.3897 47.4428 78.1332 50.483C76.306 54.9045 73.6277 58.922 70.2514 62.3061C63.4325 69.1406 54.1842 72.9802 44.5409 72.9802C40.721 72.9802 36.9386 72.226 33.4096 70.7608C29.8806 69.2956 26.6741 67.1479 23.9732 64.4405C21.2723 61.7332 19.13 58.519 17.6685 54.9818C16.207 51.4445 15.455 47.6533 15.4554 43.8247C15.4554 40.762 16.0574 37.7293 17.2268 34.8998C18.3963 32.0703 20.1103 29.4994 22.2712 27.334C24.432 25.1685 26.9973 23.4508 29.8205 22.2791C32.6436 21.1074 35.6695 20.5045 38.7251 20.505C39.4895 20.505 40.2491 20.5521 41 20.6447M41 20.6447C44.455 21.071 47.7254 22.461 50.4348 24.6585M50.4348 24.6585C50.9392 25.0676 51.4242 25.5046 51.8873 25.9687C53.709 27.7943 55.1143 29.9594 56.0418 32.3156M56.0418 32.3156C56.8917 34.4746 57.3404 36.7941 57.3409 39.1601C57.3409 39.7784 57.3026 40.3928 57.2273 41" stroke="white" stroke-linecap="round" stroke-linejoin="round">
                          </path>
                        </svg>
                      </div>
                    </div>
                    BRANDING
                  </h1>
                </div>
              </div>
              <div className='sideside' style={{ width: "35%" }}></div>
              <div className='sideDiv'>
                <h1>
                  <div class="animirani-div"><div data-w-id="a21b7f03-16e6-4d84-2816-1bc763f31d03" class="svg_div" style={{ transform: "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(360deg) skew(0deg, 0deg)", transformStyle: "preserve-3d" }}>
                    <div class="slicica_aset second w-embed"><svg id="eiJo4rZE7fS1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 118 96" shape-rendering="geometricPrecision" text-rendering="geometricPrecision">
                      <g id="eiJo4rZE7fS2_tr" transform="translate(40.747952,48) rotate(360)">
                        <g transform="translate(-40.747952,-41)">
                          <path d="M58.1643,77.0447C52.9331,79.5965,47,81,40.748,81C18.6747,81,0.748047,63.0734,0.748047,41s17.926653-40,39.999953-40c22.0734,0,40,17.9266,40,40c0,13.4609-6.6985,25.3908-16.9058,32.6635" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"></path><g id="eiJo4rZE7fS4_to" transform="translate(59,41)">
                            <path id="eiJo4rZE7fS4" d="M25,41h16.6397C51.2042,41,59,33.3035,59,23.8607v0v0C59,33.3035,66.7958,41,76.3603,41L93,41h-16.6397C66.7958,41,59,48.6965,59,58.1393v0v0C59,48.6965,51.2042,41,41.6397,41L25,41Z" transform="translate(-59,-41)" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10">
                            </path>
                          </g>
                          <path d="M13.3789,70C5.73684,62.75,1,52.4474,1,41C1,29.6162,5.73684,19.3136,13.3789,12C2.45263,22.4934,9.96842,41,25,41C9.96842,41,2.45263,59.5702,13.3789,70Z" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10">
                          </path>
                          <g id="eiJo4rZE7fS6_to" transform="translate(105,41)">
                            <path d="M104.621,70C112.263,62.75,117,52.4474,117,41c0-11.3838-4.737-21.6864-12.379-29C115.547,22.4298,108.032,41,93,41c15.032,0,22.547,18.5702,11.621,29Z" transform="translate(-105,-41)" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10">
                            </path>
                          </g>
                          <g id="eiJo4rZE7fS7_to" transform="translate(77.253948,41)">
                            <path d="M59.8376,4.95534C65.0689,2.40351,71.0019,1,77.2539,1C99.3273,1,117.254,18.9266,117.254,41s-17.9267,40-40.0001,40-40-17.9266-40-40c0-13.3971,6.571-25.2632,16.7145-32.53588" transform="translate(-77.253948,-41)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10">
                            </path>
                          </g>
                        </g>
                      </g>
                    </svg>
                    </div>
                  </div>
                  </div>
                  DESIGNING
                </h1>
                <h1 className='two'>
                  <div data-w-id="a21b7f03-16e6-4d84-2816-1bc763f31d0a" class="svg_div" style={{ transform: "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(360deg) skew(0deg, 0deg)", transformStyle: "preserve-3d" }}>
                    <div class="slicica_aset third w-embed"><svg id="ezQX1Cbfag71" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 86 92" shape-rendering="geometricPrecision" text-rendering="geometricPrecision">
                      <circle r="40" transform="translate(41 48)" fill="none" stroke="#fff">
                      </circle>
                      <g id="ezQX1Cbfag73_to" transform="translate(41,48)">
                        <circle r="32" transform="translate(0,0)" fill="none" stroke="#fff">
                        </circle>
                      </g>
                      <g id="ezQX1Cbfag74_to" transform="translate(41,48)">
                        <circle r="24" transform="translate(0,0)" fill="none" stroke="#fff">
                        </circle>
                      </g>
                      <g id="ezQX1Cbfag75_to" transform="translate(41,48)">
                        <circle r="16" transform="translate(0,0)" fill="none" stroke="#fff">
                        </circle>
                      </g>
                      <g id="ezQX1Cbfag76_to" transform="translate(41,48)">
                        <circle r="8" transform="translate(0,0)" fill="#fff" stroke="#fff">
                        </circle>
                      </g>
                    </svg>
                    </div>

                  </div>
                  DEVELOPMENT
                </h1>
              </div>
            </div>
            {/* <div className='videoDiv'>
              <video width="100%" height="100%" autoplay="autoplay" loop="loop" muted="muted" playsinline="playsinline">
                <source src={video} type="video/webm" />
              </video>
            </div> */}
          </Container>
        </div>

        <div id='what-we-do'></div>

        <motion.div className="img-inner" style={{ translateY: imageValue }}>
          <div className='what-we-do'>
            <Container>
              <Row>
                <Col md={12}>
                  <article>
                    <div className='heading'>
                      <h6>What Can I do for you?</h6>
                    </div>
                  </article>
                  <div className='single single1'>
                    <div className='img-abs'>
                      <img src={what1} alt='Graphic Design' />
                    </div>
                    <Row>
                      <Col xl={7} lg={6}>
                        <div className='heading'>
                          <h2>Graphic Design</h2>
                        </div>
                      </Col>
                      <Col xl={5} lg={6}>
                        <div className='text-div'>
                          <p>
                          Elevating ideas through captivating visuals.
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <hr />
                  <div className='single single2'>
                    <div className='img-abs'>
                      <img src={what2} alt='Experience Design' />
                    </div>
                    <Row>
                      <Col xl={7} lg={6}>
                        <div className='heading'>
                          <h2>Experience Design</h2>
                        </div>
                      </Col>
                      <Col xl={5} lg={6}>
                        <div className='text-div'>
                          <p>
                          Crafting seamless digital experiences that prioritize user satisfaction and engagement.
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <hr />
                  <div className='single single3'>
                    <div className='img-abs'>
                      <img src={what3} alt='Web Design' />
                    </div>
                    <Row>
                      <Col xl={7} lg={6}>
                        <div className='heading'>
                          <h2>Web Design</h2>
                        </div>
                      </Col>
                      <Col xl={5} lg={6}>
                        <div className='text-div'>
                          <p>
                          Captivating concepts into functional and dynamic websites.
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <hr />
                  <div className='single single4'>
                    <div className='img-abs'>
                      <img src={what4} alt='Development' />
                    </div>
                    <Row>
                      <Col xl={7} lg={6}>
                        <div className='heading'>
                          <h2>Development</h2>
                        </div>
                      </Col>
                      <Col xl={5} lg={6}>
                        <div className='text-div'>
                          <p>
                          Transforming the future of the digital world through meticulously crafted websites.
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </motion.div>
      </div >

      {
        window.screen.width < 650 &&
        <CardAnimationWeb imageValue2={imageValue2} />
      }

      < div ref={containerRef2} style={{ background: "#fff" }}>
        <HorizontalScrollSection2 />

        <CardAnimation imageValue2={imageValue2} />
      </div >

      {
        window.screen.width > 650 ?
          <ScrollAnimation />
          :
          null
      }

      < div className='brandingSection socialMediaSection' >
        <div className='heading text-white'>
          <h2>Branding</h2>
        </div>
        <Carousel3D />
        <div className='btn-div'>
          <a href='https://clients.muhammadprojects.com/new-muhammad/branding/'>
            <button name='Explore More Branding'>Explore More Branding</button>
          </a>
        </div>
      </div >

      <div className='brandingSection uiux'>
        <div className='heading'>
          <h2>UI/UX</h2>
        </div>

        <Container>
          <Row>
            <Col md={4}>
              <div className='brandDiv'>
                <div className='img-div'>
                  <div className='borderDiv'></div>
                  <div className='borderDiv two'></div>
                  <img src={uiux1} alt='UI/UX' />
                </div>
                {/* <div className='heading'>
                  <article>
                    <h4>UI/UX</h4>
                  </article>
                </div> */}
              </div>
            </Col>
            <Col md={4}>
              <div className='brandDiv'>
                <div className='img-div'>
                  <div className='borderDiv'></div>
                  <div className='borderDiv two'></div>
                  <img src={uiux2} alt='UI/UX' />
                </div>
                {/* <div className='heading'>
                  <article>
                    <h4>UI/UX</h4>
                  </article>
                </div> */}
              </div>
            </Col>
            <Col md={4}>
              <div className='brandDiv'>
                <div className='img-div'>
                  <div className='borderDiv'></div>
                  <div className='borderDiv two'></div>
                  <img src={uiux3} alt='UI/UX' />
                </div>
                {/* <div className='heading'>
                  <article>
                    <h4>UI/UX</h4>
                  </article>
                </div> */}
              </div>
            </Col>
            <Col md={4}>
              <div className='brandDiv'>
                <div className='img-div'>
                  <div className='borderDiv'></div>
                  <div className='borderDiv two'></div>
                  <img src={uiux4} alt='UI/UX' />
                </div>
                {/* <div className='heading'>
                  <article>
                    <h4>UI/UX</h4>
                  </article>
                </div> */}
              </div>
            </Col>
            <Col md={4}>
              <div className='brandDiv'>
                <div className='img-div'>
                  <div className='borderDiv'></div>
                  <div className='borderDiv two'></div>
                  <img src={uiux5} alt='UI/UX' />
                </div>
                {/* <div className='heading'>
                  <article>
                    <h4>UI/UX</h4>
                  </article>
                </div> */}
              </div>
            </Col>
            <Col md={4}>
              <div className='brandDiv'>
                <div className='img-div'>
                  <div className='borderDiv'></div>
                  <div className='borderDiv two'></div>
                  <img src={uiux6} alt='UI/UX' />
                </div>
                {/* <div className='heading'>
                  <article>
                    <h4>UI/UX</h4>
                  </article>
                </div> */}
              </div>
            </Col>

            <Col md={12}>
              <div className='btn-div'>
                <a href='https://clients.muhammadprojects.com/new-muhammad/ui-ux/'>
                  <button name='Explore More UI/UX'>Explore More UI/UX</button>
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className='brandingSection socialMediaSection'>
        <div className='heading text-white'>
          <h2>Social Media</h2>
        </div>

        <Container>
          <Row>
            <Col md={4}>

              <div className='brandDiv'>
                <div className='img-div'>
                  <motion.div
                    initial={false}
                    animate={
                      isLoaded && isInView
                        ? { WebkitMaskImage: visibleMask, maskImage: visibleMask }
                        : { WebkitMaskImage: hiddenMask, maskImage: hiddenMask }
                    }
                    transition={{ duration: 1, delay: 0 }}
                    viewport={{ once: false }}
                    onViewportEnter={() => setIsInView(true)}
                    onViewportLeave={() => setIsInView(false)}
                  >
                    <img onLoad={() => setIsLoaded(true)} src={ssm1} alt='Social media' />
                  </motion.div>
                </div>
                {/* <div className='heading text-white'>
                  <article>
                    <h4>Social media</h4>
                  </article>
                </div> */}
              </div>
            </Col>
            <Col md={4}>

              <div className='brandDiv'>
                <div className='img-div'>
                  <motion.div
                    initial={false}
                    animate={
                      isLoaded2 && isInView2
                        ? { WebkitMaskImage: visibleMask, maskImage: visibleMask }
                        : { WebkitMaskImage: hiddenMask, maskImage: hiddenMask }
                    }
                    transition={{ duration: 1, delay: 0 }}
                    viewport={{ once: false }}
                    onViewportEnter={() => setIsInView2(true)}
                    onViewportLeave={() => setIsInView2(false)}
                  >
                    <img onLoad={() => setIsLoaded2(true)} src={ssm2} alt='Social media' />
                  </motion.div>
                </div>
                {/* <div className='heading text-white'>
                  <article>
                    <h4>Social media</h4>
                  </article>
                </div> */}
              </div>
            </Col>
            <Col md={4}>

              <div className='brandDiv'>
                <div className='img-div'>
                  <motion.div
                    initial={false}
                    animate={
                      isLoaded3 && isInView3
                        ? { WebkitMaskImage: visibleMask, maskImage: visibleMask }
                        : { WebkitMaskImage: hiddenMask, maskImage: hiddenMask }
                    }
                    transition={{ duration: 1, delay: 0 }}
                    viewport={{ once: false }}
                    onViewportEnter={() => setIsInView3(true)}
                    onViewportLeave={() => setIsInView3(false)}
                  >
                    <img onLoad={() => setIsLoaded3(true)} src={ssm7} alt='Social media' />
                  </motion.div>
                </div>
                {/* <div className='heading text-white'>
                  <article>
                    <h4>Social media</h4>
                  </article>
                </div> */}
              </div>
            </Col>
            <Col md={4}>

              <div className='brandDiv'>
                <div className='img-div'>
                  <motion.div
                    initial={false}
                    animate={
                      isLoaded4 && isInView4
                        ? { WebkitMaskImage: visibleMask, maskImage: visibleMask }
                        : { WebkitMaskImage: hiddenMask, maskImage: hiddenMask }
                    }
                    transition={{ duration: 1, delay: 0 }}
                    viewport={{ once: false }}
                    onViewportEnter={() => setIsInView4(true)}
                    onViewportLeave={() => setIsInView4(false)}
                  >
                    <img onLoad={() => setIsLoaded4(true)} src={ssm4} alt='Social media' />
                  </motion.div>
                </div>
                {/* <div className='heading text-white'>
                  <article>
                    <h4>Social media</h4>
                  </article>
                </div> */}
              </div>
            </Col>
            <Col md={4}>
              <div className='brandDiv'>
                <div className='img-div'>
                  <motion.div
                    initial={false}
                    animate={
                      isLoaded5 && isInView5
                        ? { WebkitMaskImage: visibleMask, maskImage: visibleMask }
                        : { WebkitMaskImage: hiddenMask, maskImage: hiddenMask }
                    }
                    transition={{ duration: 0.7, delay: 0 }}
                    viewport={{ once: false }}
                    onViewportEnter={() => setIsInView5(true)}
                    onViewportLeave={() => setIsInView5(false)}
                  >
                    <img onLoad={() => setIsLoaded5(true)} src={ssm8} alt='Social media' />
                  </motion.div>
                </div>
                {/* <div className='heading text-white'>
                  <article>
                    <h4>Social media</h4>
                  </article>
                </div> */}
              </div>
            </Col>
            <Col md={4}>

              <div className='brandDiv'>
                <div className='img-div'>
                  <motion.div
                    initial={false}
                    animate={
                      isLoaded6 && isInView6
                        ? { WebkitMaskImage: visibleMask, maskImage: visibleMask }
                        : { WebkitMaskImage: hiddenMask, maskImage: hiddenMask }
                    }
                    transition={{ duration: 1, delay: 0 }}
                    viewport={{ once: false }}
                    onViewportEnter={() => setIsInView6(true)}
                    onViewportLeave={() => setIsInView6(false)}
                  >
                    <img onLoad={() => setIsLoaded6(true)} src={ssm6} alt='Social media' />
                  </motion.div>
                </div>
                {/* <div className='heading text-white'>
                  <article>
                    <h4>Social media</h4>
                  </article>
                </div> */}
              </div>
            </Col>

            <Col md={12}>
              <div className='btn-div'>
                <a href='https://clients.muhammadprojects.com/new-muhammad/social-media/'>
                  <button name='Explore More Social Media'>Explore More Social Media</button>
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <WhatWeDone />

      <div className='brandingSection partnerSection'>
        <Container>
          <div className='heading text-white'>
            <h2>Partners</h2>
          </div>

          <div className='text-div text-center'>
            <p>Strong business relationships mean that when I work with you,
              I’m in it for the long run to fulfill any need of yours that I can.</p>
          </div>
          <div className='parnerSlider'>
            <Slider {...settings}>
              <div className='partnerLogo'>
                <img src={partner1} alt='partner' />
              </div>
              <div className='partnerLogo'>
                <img src={partner2} alt='partner' />
              </div>
              <div className='partnerLogo'>
                <img src={partner3} alt='partner' />
              </div>
              <div className='partnerLogo'>
                <img src={partner4} alt='partner' />
              </div>
              <div className='partnerLogo'>
                <img src={partner5} alt='partner' />
              </div>
              <div className='partnerLogo'>
                <img src={partner6} alt='partner' />
              </div>
              <div className='partnerLogo'>
                <img src={partner7} alt='partner' />
              </div>
              <div className='partnerLogo'>
                <img src={partner8} alt='partner' />
              </div>
              <div className='partnerLogo'>
                <img src={partner9} alt='partner' />
              </div>
              <div className='partnerLogo'>
                <img src={partner10} alt='partner' />
              </div>
            </Slider>


          </div>
          <div class="gradientsep"></div>
        </Container>
      </div>

      <ReviewsSection />

      <Footer />

    </div >
  );
};

export default App;

document.addEventListener('DOMContentLoaded', function () {
  var dropdownContainer = document.querySelector('.mobile-drop-down-container');
  var dropdownMenu = document.querySelector('.mobile-drop-down-menu-box');
  var angleIcon = document.querySelector('.mobile-drop-down-icon');

  // Initially, hide the dropdown menu
  dropdownMenu.style.display = 'none';

  // Flag to track the dropdown state
  var dropdownOpen = false;

  // Add a click event listener to the angle icon to toggle the dropdown
  angleIcon.addEventListener('click', function (e) {
    e.stopPropagation(); // Prevent the event from bubbling up and closing the menu
    dropdownMenu.style.display = dropdownOpen ? 'none' : 'block';
    dropdownOpen = !dropdownOpen; // Toggle the dropdown state
  });

  // Add click event listeners to the individual list items
  var listItems = document.querySelectorAll('.mobile-drop-down-menu-box li');
  listItems.forEach(function (item) {
    item.addEventListener('click', function (e) {
      // The default link behavior will occur when clicking on list items
    });
  });

  // Close the dropdown menu when clicking outside of it
  document.addEventListener('click', function (e) {
    if (e.target !== dropdownContainer && e.target !== angleIcon) {
      dropdownMenu.style.display = 'none';
      dropdownOpen = false; // Reset the dropdown state
    }
  });
});


